import { useSelector } from 'react-redux'

const useUISelectors = (errorSelector, loadingSelector) => {
	const isLoading = useSelector(loadingSelector)
	const error = useSelector(errorSelector)
	return { isLoading, error }
}
export default useUISelectors
